import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ZTag } from '@zanichelli/albe-web-components/react';

import CorrectionResults from '../correction-results';
import { getUnitutorTotalScore } from '../../lib/correction';
import { sectionPropType } from '../../lib/prop-types';
import { getSectionCompletionTime } from '../../lib/status';
import { getTimeString } from '../../lib/utils';

export const HeaderAndResultsContainer = styled.div`
    &:not(:first-of-type) {
        padding-top: calc(var(--space-unit) * 2);
    }
`;

const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding-bottom: var(--space-unit);
`;

const ZTagsContainer = styled.div`
    display: flex;
    gap: var(--space-unit);
`;

const StyledZTag = styled(ZTag)`
    --z-tag-bg: var(--gray800);
    --z-tag-text-color: var(--color-white);
    text-transform: capitalize;

    & span {
        font-weight: var(--font-rg);
    }
`;

export const CorrectionResultsBySections = ({
    answers = [],
    exercises,
    expand,
    filter,
    geogebraExercises,
    correctionsStatus,
    videos,
    onPlayVideo,
    correctionPoints,
    source,
    sections,
    scoreModifier,
    showScore,
}) => {
    const calculateFirstExerciseIndex = (currentSectionIndex) => {
        let firstExerciseIndex = 0;

        for (let i = 0; i < currentSectionIndex; i++) {
            firstExerciseIndex += sections[i].exercisesCount;
        }

        return firstExerciseIndex;
    };

    return (
        <div>
            {sections.map((section, index) => {
                const firstExerciseIndex = calculateFirstExerciseIndex(index);
                const sectionExercises = exercises.slice(firstExerciseIndex, firstExerciseIndex + section.exercisesCount);

                let sectionPoints = 0;
                let sectionTotalPoints = 0;
                if (showScore) {
                    const sectionExercisesIds = sectionExercises.map((sectionExercise) => sectionExercise.id);

                    sectionPoints = getUnitutorTotalScore(
                        correctionPoints.filter((correction) => sectionExercisesIds.includes(correction.exerciseId)),
                        scoreModifier,
                    );
                    sectionTotalPoints = sectionExercises.length * scoreModifier.correct;
                }

                return (
                    <HeaderAndResultsContainer key={section.name}>
                        <SectionHeader className="body-2-sb">
                            {section.name}
                            {showScore && (
                                <ZTagsContainer>
                                    <StyledZTag>
                                        {`Tempo: ${getTimeString(getSectionCompletionTime(section))}`}
                                        <span>{`/${getTimeString(section.time)}`}</span>
                                    </StyledZTag>
                                    <StyledZTag>
                                        {`Punteggio: ${sectionPoints.toFixed(2)}`}
                                        <span>{`/${sectionTotalPoints}`}</span>
                                    </StyledZTag>
                                </ZTagsContainer>
                            )}
                        </SectionHeader>
                        <CorrectionResults
                            answers={answers}
                            correctionsStatus={correctionsStatus}
                            exercises={sectionExercises}
                            expand={expand}
                            filter={filter}
                            geogebraExercises={geogebraExercises}
                            onPlayVideo={onPlayVideo}
                            videos={videos}
                            correctionPoints={correctionPoints}
                            source={source}
                            exerciseIndexOffset={firstExerciseIndex}
                        />
                    </HeaderAndResultsContainer>
                );
            })}
        </div>
    );
};

CorrectionResultsBySections.propTypes = {
    answers: PropTypes.array,
    exercises: PropTypes.array,
    expand: PropTypes.bool,
    filter: PropTypes.string,
    geogebraExercises: PropTypes.array,
    correctionsStatus: PropTypes.array,
    onPlayVideo: PropTypes.func,
    videos: PropTypes.array,
    correctionPoints: PropTypes.array,
    source: PropTypes.string,
    sections: PropTypes.arrayOf(sectionPropType),
    scoreModifier: PropTypes.object,
    showScore: PropTypes.bool,
};

export default CorrectionResultsBySections;
